<section class="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-green-100 text-gray-800 overflow-hidden">

<div class="absolute inset-0 overflow-hidden pointer-events-none">
    <div class="absolute top-20 left-10 w-64 h-64 bg-emerald-200/30 rounded-full blur-3xl"></div>
    <div class="absolute bottom-10 right-10 w-80 h-80 bg-green-300/20 rounded-full blur-3xl"></div>
</div>

<main class="relative z-10 flex min-h-screen items-center justify-center px-6 py-12">
    <div class="max-w-3xl w-full">
        <div class="bg-white/80 backdrop-blur-xl border border-white shadow-2xl rounded-[2rem] p-8 md:p-14 text-center">

            <div class="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6 pulse-soft">
                <span class="w-2 h-2 rounded-full bg-emerald-500"></span>
                Patriacura Plattform
            </div>

            <div class="relative inline-block mb-8 float">
                <div class="text-[120px] md:text-[170px] font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-app-primary-10 to-green-700 leading-none">
                    404
                </div>

                <div class="absolute -top-3 -right-3 rotate-12 bg-white border border-emerald-100 shadow-lg rounded-2xl px-4 py-2 text-sm font-medium text-gray-600">
                    Rezept verlegt ?
                </div>
            </div>

            <h1 class="text-3xl md:text-5xl font-extrabold tracking-tight mb-5 text-app-primary-10">
                Diese Seite ist gerade auf Visite.
            </h1>

            <p class="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto mb-10">
                Entweder existiert die Seite nicht mehr oder sie hat sich eine kleine digitale Auszeit verschrieben.
                Keine Sorge – unser Support hat keinen Notfall ausgerufen.
            </p>

            <div class="grid gap-4 sm:grid-cols-2 max-w-xl mx-auto mb-10">
                <a href="/home"
                   class="group inline-flex items-center justify-center gap-2 rounded-2xl bg-app-primary-10 hover:bg-emerald-700 transition-all px-6 py-4 text-white font-semibold shadow-lg shadow-emerald-200">
                    Zur Startseite
                </a>

                <a href="/kontakt"
                   class="inline-flex items-center justify-center gap-2 rounded-2xl border border-gray-200 hover:border-emerald-300 hover:bg-emerald-50 transition-all px-6 py-4 text-gray-700 font-semibold bg-white">
                    Support kontaktieren
                </a>
            </div>

            <div class="mt-10 border-t border-gray-100 pt-6 text-sm text-gray-400">
                Fehlercode 404 · Vielleicht war der Link einfach etwas zu entspannt.
            </div>
        </div>
    </div>
</main>

</section>
